<script>
  import { LayerCake, Svg } from "layercake";

  import { AxisX, AxisY, Tooltip } from "@urbaninstitute/dataviz-components";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";
  import { normalFormat, roundFormat } from "$utils/formats.js";
  import { getStateName } from "$utils/states.js";
  import Line from "./Line.svelte";

  // This example loads csv data as json and converts numeric columns to numbers using @rollup/plugin-dsv. See vite.config.js for details
  //import data from './_data/points.csv';
  let { data, currentState, tooltipLabel } = $props();

  const xKey = "year";
  const yKey = "value";

  let hoveredPoint = $state(null);
</script>

<div class="chart-container">
  <LayerCake
    padding={{ top: 20, right: 40, bottom: 20, left: 50 }}
    x={xKey}
    y={yKey}
    yDomain={[0, null]}
    yNice={true}
    {data}
    custom={{ seriesColors: [urbanColors.yellow] }}
  >
    <Svg>
      <AxisX ticks={5} />
      <AxisY ticks={4} formatTick={(d) => roundFormat.format(d)} />
      <Line bind:hoveredPoint />
    </Svg>
  </LayerCake>
  {#if hoveredPoint}
    <Tooltip el={hoveredPoint.target}>
      <span class="underlined">{getStateName(currentState)}</span><br /><br />
      <i>{hoveredPoint.year}:</i>
      <strong>{normalFormat.format(hoveredPoint.value)}</strong>
      {tooltipLabel.toLowerCase() == "chronic homelessness" ||
      tooltipLabel.toLowerCase() == "unsheltered homelessness"
        ? " experiencing "
        : ""}
      {tooltipLabel.toLowerCase()}
    </Tooltip>
  {/if}
</div>

<style>
  .underlined {
    border-bottom: 3px solid var(--color-yellow);
  }

  /*
    The wrapper div needs to have an explicit width and height in CSS.
    It can also be a flexbox child or CSS grid element.
    The point being it needs dimensions since the <LayerCake> element will
    expand to fill it.
  */
  .chart-container {
    width: 100%;
    height: 250px;
  }
</style>
